// Module
var code = `<div class="notificationsItemSideBar{{#if !isUnread}} read{{/if}}{{#if .isSelected}} selected{{/if}}"
     style="background:
            linear-gradient(90deg,
            color-mix(in srgb, {{.rgbColor}} 40%, transparent) 0%,
            color-mix(in srgb, {{.rgbColor}} 20%, transparent) 50%,
            color-mix(in srgb, {{.rgbColor}} 0%, transparent) 100%);"
     on-click="cardClick">
    <div class="notificationsItemSideBar-line" style="background-color: {{.rgbColor}};"></div>

    <div class="notificationsItemSideBar-text-container">
        <div class="container-title">
            <div class="title">{{.Title}}</div>
            <div class="date">{{.Date}}</div>
        </div>

        <div class="only-text">{{.OnlyText}}</div>
    </div>

    <div class="notificationsItemSideBar-arrow">
        <svg>
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowDown"></use>
        </svg>
    </div>

</div>`;
// Exports
export default code;